export const hexToRgba = (hex: string, opacity: number) => {
    const sanitized = hex.replace("#", "");

    const bigint = parseInt(sanitized, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
